import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import css_248z from './verification-gate.scss.js';

class VerificationGate extends s {
    constructor() {
        super(...arguments);
        this.mainTitle = '';
        this.subtitle = '';
        this.moreInfoText = '';
        this.moreInfoContent = '';
        this.accessInstructionText = '';
        this.loginButtonText = '';
        this.loginButtonUrl = '';
        this.loginButtonTarget = '';
        this.createAccountButtonText = '';
        this.createAccountButtonUrl = '';
        this.createAccountButtonTarget = '';
        this.notProfessionalText = '';
        this.showMoreInfoButton = true;
        this.moreInfoExpanded = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setupSecurityObserver();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.setupShadowDOMObserver();
    }
    setupSecurityObserver() {
        this.mutationObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.removedNodes.forEach(node => {
                    var _a;
                    if (node === this || ((_a = node === null || node === void 0 ? void 0 : node.contains) === null || _a === void 0 ? void 0 : _a.call(node, this))) {
                        window.location.reload();
                    }
                });
            });
        });
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
    setupShadowDOMObserver() {
        if (!this.shadowRoot)
            return;
        this.shadowObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    VerificationGate.handleRemovedNodes(mutation.removedNodes);
                }
                if (mutation.type === 'attributes') {
                    VerificationGate.handleAttributeChanges(mutation.target);
                }
            });
        });
        this.shadowObserver.observe(this.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class'],
        });
    }
    static isCriticalElement(element) {
        var _a;
        return (element.classList.contains('modal-overlay') ||
            element.classList.contains('verification-gate') ||
            !!((_a = element.querySelector) === null || _a === void 0 ? void 0 : _a.call(element, '.modal-overlay')));
    }
    static isElementHidden(element) {
        const style = getComputedStyle(element);
        return (style.display === 'none' ||
            style.visibility === 'hidden' ||
            style.opacity === '0');
    }
    static handleRemovedNodes(removedNodes) {
        removedNodes.forEach(node => {
            if (node instanceof Element && VerificationGate.isCriticalElement(node)) {
                window.location.reload();
            }
        });
    }
    static handleAttributeChanges(target) {
        if (VerificationGate.isCriticalElement(target) &&
            VerificationGate.isElementHidden(target)) {
            window.location.reload();
        }
    }
    toggleMoreInfo(e) {
        e.preventDefault();
        this.moreInfoExpanded = !this.moreInfoExpanded;
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.moreInfoExpanded = !this.moreInfoExpanded;
        }
    }
    handleLoginButtonClick(e) {
        e.preventDefault();
        if (this.loginButtonUrl) {
            if (this.loginButtonTarget === '_blank') {
                window.open(this.loginButtonUrl, '_blank');
            }
            else {
                window.location.href = this.loginButtonUrl;
            }
        }
    }
    handleCreateAccountButtonClick(e) {
        e.preventDefault();
        if (this.createAccountButtonUrl) {
            if (this.createAccountButtonTarget === '_blank') {
                window.open(this.createAccountButtonUrl, this.createAccountButtonTarget);
            }
            else {
                window.location.href = this.createAccountButtonUrl;
            }
        }
    }
    renderAccessInstructionText() {
        if (!this.accessInstructionText) {
            return '';
        }
        return $ `<div class="access-instruction rte">${o(wrapRichTextTables(this.accessInstructionText))}</div>`;
    }
    renderNotProfessionalText() {
        if (!this.notProfessionalText) {
            return '';
        }
        return $ `<div class="footer"><div class="non-hcp-content rte">${o(wrapRichTextTables(this.notProfessionalText))}</div></div>`;
    }
    renderMoreInfoContent() {
        if (!this.moreInfoContent) {
            return '';
        }
        return $ `<div class="more-info-content" id="more-info-content"><div class="rte">${o(wrapRichTextTables(this.moreInfoContent))}</div></div>`;
    }
    renderMoreInfo() {
        if (!this.showMoreInfoButton ||
            !this.moreInfoText ||
            !this.moreInfoContent) {
            return '';
        }
        const toggleIcon = this.moreInfoExpanded ? '-' : '+';
        const ariaExpanded = this.moreInfoExpanded ? 'true' : 'false';
        return $ `<div class="more-info-container"><div @click="${this.toggleMoreInfo}" @keydown="${this.handleKeyDown}" class="more-info-header" tabindex="0" role="button" aria-expanded="${ariaExpanded}" aria-controls="more-info-content"><span class="more-info-text">${this.moreInfoText}</span> <span class="toggle-icon">${toggleIcon}</span></div>${this.moreInfoExpanded ? this.renderMoreInfoContent() : ''}</div>`;
    }
    render() {
        return $ `<div class="modal-overlay"><div class="verification-gate"><div class="vg__header"><h1 class="vg__title">${this.mainTitle}</h1></div><div class="vg__body"><div class="vg__subtitle rte">${o(wrapRichTextTables(this.subtitle))}</div>${this.renderMoreInfo()} ${this.renderAccessInstructionText()}<div class="buttons-container"><button class="login-button" aria-label="${this.loginButtonText}" @click="${this.handleLoginButtonClick}">${this.loginButtonText}</button> <button class="create-account-button" aria-label="${this.createAccountButtonText}" @click="${this.handleCreateAccountButtonClick}">${this.createAccountButtonText}</button></div>${this.renderNotProfessionalText()}</div></div></div>`;
    }
}
VerificationGate.styles = css_248z;
__decorate([
    e({ type: String })
], VerificationGate.prototype, "mainTitle", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "subtitle", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "moreInfoText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "moreInfoContent", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "accessInstructionText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonUrl", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonTarget", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonUrl", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonTarget", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "notProfessionalText", void 0);
__decorate([
    e({ type: Boolean })
], VerificationGate.prototype, "showMoreInfoButton", void 0);
__decorate([
    t()
], VerificationGate.prototype, "moreInfoExpanded", void 0);
customElements.define('verification-gate', VerificationGate);

export { VerificationGate };
